/**
 * Single source of truth for "is this a Test / CoLiviq account" — used to
 * exclude internal/test accounts from the default Bookings & Tenants view
 * and to bucket them under their own Directory tab.
 *
 * Two layers:
 *  - Static rules baked into the app (the @coliviq.de domain, plus a handful
 *    of seed emails used by the team for manual testing). These never change
 *    at runtime, so there's no reason to round-trip them through the DB.
 *  - Dynamic emails added by admins through the Directory UI, persisted in
 *    public.test_account_filters and passed in by the caller.
 */

const TEST_ACCOUNT_DOMAIN = "@coliviq.de";

const TEST_ACCOUNT_SEED_EMAILS: ReadonlySet<string> = new Set([
  "neel.g.nathan@gmail.com",
  "nathanneel1@gmail.com",
  "neel@ddvc.ch",
  "vishnuravichandran.28@gmail.com",
]);

export function isTestAccount(
  email: string | null | undefined,
  dynamicEmails: readonly string[] = []
): boolean {
  const normalized = email?.trim().toLowerCase();
  if (!normalized) return false;

  if (normalized.endsWith(TEST_ACCOUNT_DOMAIN)) return true;
  if (TEST_ACCOUNT_SEED_EMAILS.has(normalized)) return true;
  return dynamicEmails.some(
    (candidate) => candidate.trim().toLowerCase() === normalized
  );
}
